import { AnimatePresence, motion } from "motion/react";
import React from "react";

export const Crossfade = ({ children, viewKey }: { children: React.ReactNode; viewKey: string }) => {
	return (
		<AnimatePresence initial={false} mode="popLayout" custom={viewKey}>
			<motion.div
				key={viewKey}
				transition={{ duration: 0.15, ease: "easeOut" }}
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
			>
				{children}
			</motion.div>
		</AnimatePresence>
	);
};
